import React from 'react';
import { Link } from 'react-router-dom';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-xl shadow">
          <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
          <p className="text-gray-700 mb-4">
            These Terms of Service govern your use of our website. By accessing or using the site you agree to be bound by these terms. Please read them carefully.
          </p>
          <section className="mb-4">
            <h2 className="text-xl font-semibold mb-2">Use of the Site</h2>
            <p className="text-gray-700">You agree not to use the site for any unlawful purpose and to follow all applicable laws and regulations.</p>
          </section>
          <section className="mb-4">
            <h2 className="text-xl font-semibold mb-2">Intellectual Property</h2>
            <p className="text-gray-700">All content on the site is the property of Alhaji Inusah Foundation or its licensors unless otherwise stated.</p>
          </section>
          <section className="mb-4">
            <h2 className="text-xl font-semibold mb-2">Contact</h2>
            <p className="text-gray-700">For questions about these terms, please contact us through the contact page.</p>
          </section>
          <div className="mt-6">
            <Link to="/" className="text-primary-600 hover:underline">Back to Home</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
